// Centralized event bus for cross-app task-related events

export type AppEventMap = {
  'assignedTasks:changed': CustomEvent<void>;
};

// Emitters
export function emitAssignedTasksChanged(): void {
  try {
    window.dispatchEvent(new CustomEvent('assignedTasks:changed'));
  } catch {}
}

// Generic subscribe/unsubscribe helpers
export function on<EventKey extends keyof AppEventMap>(
  type: EventKey,
  listener: (evt: AppEventMap[EventKey]) => void,
): () => void {
  const l = listener as EventListener;
  window.addEventListener(type as string, l);
  return () => window.removeEventListener(type as string, l);
}

export function once<EventKey extends keyof AppEventMap>(
  type: EventKey,
  listener: (evt: AppEventMap[EventKey]) => void,
): void {
  const l = ((e: Event) => {
    listener(e as AppEventMap[typeof type]);
    window.removeEventListener(type as string, l);
  }) as EventListener;
  window.addEventListener(type as string, l);
}
